// Xpnsr SEO — i18n entry point.
//
// The former monolithic `frontend/src/i18n.js` was 1731 lines and
// flagged by the audit report. This package keeps the public surface
// (`translations`, `LangContext`, `useLang`, `useT`, `LangProvider`)
// while moving the locale dictionaries to per-locale modules so the
// 27 import sites in `frontend/src/` keep working unchanged.

import { useState, useEffect, createContext, useContext } from "react";

import safeStorage from "../lib/safeStorage";

import { setTxLang } from "../lib/tx";
import en from "./en";
import ru from "./ru";

export const translations = { en, ru };

export const LangContext = createContext("en");

export function useLang() {
  const ctx = useContext(LangContext);
  if (typeof ctx === "string") return { lang: ctx, switchLang: () => {} };
  return ctx;
}

export function useT() {
  const { lang } = useLang();
  return translations[lang] || translations.en;
}

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return safeStorage.getItem("xpnsr_lang") || "en";
  });

  const switchLang = (l) => {
    if (l === lang) return;
    safeStorage.setItem("xpnsr_lang", l);
    setLang(l);
    // Reload so every screen - including labels computed once at import
    // time and components that do not subscribe to the language context -
    // comes up in the new language. A partial re-render left mixed text.
    if (typeof window !== "undefined" && window.location && process.env.NODE_ENV !== "test") {
      window.location.reload();
    }
  };

  // Hardcoded UI strings wrapped in tx() follow the same switch (lib/tx.js).
  setTxLang(lang);

  return (
    <LangContext.Provider value={{ lang, switchLang }}>
      {children}
    </LangContext.Provider>
  );
}
